module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/related/en/4-dbc530f48fc635aa0b850f627123c644.jpg";